module.exports = __webpack_public_path__ + "img/modelIcon_mx.77a67e90.png";